import { useAuthStore } from "~/stores/auth";

export const useAuth = () => {
  const authStore = useAuthStore();

  const fetchUser = async () => {
    if (!authStore.token) return;
    try {
      const { $api } = useNuxtApp();
      const data = await $api.get("/user/me", "include");
      authStore.setUser(data);
      return data;
    } catch (error) {
      console.error("Failed to fetch user:", error);
      // Optional: logout if 401?
    }
  };

  return {
    // Return refs for reactivity
    user: computed(() => authStore.user),
    token: computed(() => authStore.token),
    isLoggedIn: computed(() => authStore.isLoggedIn()),
    fetchUser,
    logout: authStore.logout,
  };
};
